import React from 'react';
import './style.scss';
import CrossSellingProductsTitle from './shared/title';
import CrossSellingProductsCards from './shared/cards';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CrossSellingProductsComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CrossSellingProductsComponent" />;
  }

  const { heading, text, items, primaryButton, secondaryButton } = props?.fields;
  const style = props?.params?.Styles;

  return (
    <div className={clsx('content', 'cross-selling-products-wrapper', 'add-margins', style)}>
      <div className="cross-selling-products">
        <CrossSellingProductsTitle
          heading={heading}
          subHeading={text}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        />
        <CrossSellingProductsCards products={items} />
      </div>
    </div>
  );
};

export default CrossSellingProductsComponent;
